export enum HubSpotRecurringBillingFrequency {
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  PER_SIX_MONTHS = 'per_six_months',
  ANNUALLY = 'annually',
  PER_TWO_YEARS = 'per_two_years',
  PER_THREE_YEARS = 'per_three_years'
}
